import { useEffect } from 'react';
import { VStack } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import LottieAnimation from 'components/LottieAnimation';
import Content from 'features/TeamOnboarding/components/Content';
import Navigation from 'features/TeamOnboarding/components/Navigation/Navigation';

import { ModuleData } from '../../machine/model';
import locales from './locales';

const TIMEOUT = 3000; // 3s

interface ValidatedProps {
  moduleData: ModuleData;
  onNext: () => void;
}

const Validated = asBentoPage<ValidatedProps>(
  ({ Layout, moduleData, onNext }) => {
    useEffect(() => {
      const timeoutId = setTimeout(onNext, TIMEOUT);
      return () => clearInterval(timeoutId);
    }, [onNext]);

    return (
      <Layout nav={<Navigation />}>
        <VStack boxSize="30rem" marginX="auto" textAlign="center">
          <LottieAnimation
            animation="success"
            loop={false}
            style={{ cursor: 'initial' }}
            width="180px"
          />
          <Content
            content={
              locales.formatString<string>(locales.content, {
                companyName: moduleData.companyName,
              }) as string
            }
            title={locales.title}
          />
        </VStack>
      </Layout>
    );
  },
);

export default Validated;
